export class BaseContract {
    constructor(options) {
        Object.assign(this, options);
        this.rpcUrl = options.rpcUrl;
        this.chainId = options.chainId;
        this.type = options.type;
        this.address = options.contractAddress;
    }
}
